export const QUERY_PARAMS = ['query', 'offset', 'limit', 'sort', 'sortDirection', 'linkOperator'];
